




































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import ClassifiedOfferActionButton from '~/components/car/offers/ClassifiedOfferActionButton.vue'
import {
  ClassifiedOfferEntry,
  OfferActions,
  OfferState
} from '~/models/classified/offers'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

export default defineComponent({
  components: { ClassifiedOfferActionButton },
  props: {
    offer: {
      type: Object as PropType<ClassifiedOfferEntry>,
      required: true
    },
    preferOutline: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props) {
    const { offer } = toRefs(props)
    const statePending = computed(() => {
      return offer.value.latestBid.state === OfferState.PENDING
    })
    const stateAccepted = computed(() => {
      return offer.value.latestBid.state === OfferState.ACCEPTED
    })
    const stateRejected = computed(() => {
      return offer.value.latestBid.state === OfferState.REJECTED
    })
    const stateWithdrawn = computed(() => {
      return offer.value.latestBid.state === OfferState.WITHDRAWN
    })
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    const isCounteroffer = computed(() => {
      return statePending.value && offer.value.bidCount > 1
    })

    const received = computed(() => {
      return !userGetters('userIds').includes(offer.value.latestBid.user.id)
    })

    const initialOfferMine = computed(() => {
      return userGetters('userIds').includes(offer.value.user.id)
    })

    const showAcceptButton = computed(() => {
      return statePending.value && received.value
    })
    const showCounterButton = computed(() => {
      return (
        (received.value && statePending.value) ||
        stateRejected.value ||
        stateWithdrawn.value
      )
    })
    const showCancelButton = computed(() => {
      return (
        !(stateRejected.value || stateAccepted.value || stateWithdrawn.value) &&
        (statePending.value || !received.value)
      )
    })

    return {
      OfferActions,
      statePending,
      stateAccepted,
      stateRejected,
      stateWithdrawn,
      received,
      showAcceptButton,
      showCounterButton,
      showCancelButton,
      isCounteroffer,
      initialOfferMine
    }
  }
})
